var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1336.4 350.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #010101;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -659.82,
    y1: 1503.46,
    x2: 201.99,
    y2: 1430.4,
    gradientTransform: "translate(564 1629.57) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50c9ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#452f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ed2d85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d3d97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -635.18,
    y1: 1475.37,
    x2: 175.08,
    y2: 1406.68,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M682.92,66c1.74-1.71,3.81-3.06,6.08-3.95,2.27-.9,4.7-1.32,7.14-1.26,2.42-.07,4.83.36,7.09,1.25,2.25.9,4.3,2.24,6.01,3.96,1.71,1.72,3.06,3.76,3.95,6.01.89,2.25,1.32,4.66,1.25,7.09.05,2.38-.38,4.75-1.28,6.96-.89,2.21-2.23,4.21-3.93,5.88-1.71,1.72-3.76,3.06-6.01,3.96-2.25.9-4.67,1.32-7.09,1.25-2.44.06-4.87-.37-7.14-1.26s-4.34-2.24-6.08-3.95c-1.73-1.65-3.1-3.65-4.02-5.86-.92-2.21-1.37-4.59-1.32-6.98-.07-2.43.37-4.86,1.29-7.11.92-2.26,2.3-4.29,4.05-5.99ZM681.91,246.15V115.71h28.48v130.43h-28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M775.22,181.05v65.09h-27.96V115.71h24.66l1.79,22.62c4.41-8.09,11.03-14.75,19.09-19.21,8.06-4.46,17.22-6.52,26.42-5.96,6.7-.21,13.36.99,19.56,3.53,6.2,2.54,11.79,6.36,16.42,11.22,10.02,11.5,15.09,26.48,14.12,41.7v76.53h-27.97v-67.64c.81-10.65-2.31-21.23-8.77-29.75-2.78-3.22-6.25-5.78-10.14-7.49-3.89-1.71-8.12-2.55-12.37-2.43-4.7-.17-9.38.67-13.72,2.47-4.34,1.8-8.25,4.52-11.45,7.96-7.12,8.99-10.58,20.35-9.67,31.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M943.03,113.17v10.17h44.5v22.37h-44.5v100.44h-27.96v-100.44h-25.43v-22.37h25.43v-11.94c-.39-6.14.45-12.3,2.48-18.11,2.03-5.81,5.2-11.15,9.34-15.71,4.34-4.12,9.48-7.3,15.1-9.36,5.62-2.05,11.6-2.94,17.57-2.6,5.62-.04,11.23.39,16.77,1.28,3.63.48,7.21,1.33,10.68,2.53l3.05,1.28-3.56,21.61c-6.37-2.58-13.21-3.8-20.08-3.56-3.16-.2-6.32.25-9.29,1.32-2.98,1.07-5.7,2.74-8,4.91-2.17,2.48-3.83,5.36-4.87,8.48-1.05,3.12-1.47,6.42-1.23,9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1011.69,246.15V68.16h28.48v177.98h-28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1112.32,244.69l-53.08-128.98h31.03l35.79,94.83,38.19-94.83h29.75l-54.16,131.7c-11.36,27.97-28.65,41.96-51.87,41.96-5.18.03-10.35-.57-15.38-1.79-3.57-.73-7.03-1.93-10.29-3.55l-3.05-1.79,8.9-22.63c5.55,3.46,12.05,5.06,18.56,4.58,5.78-.12,11.38-2.07,15.98-5.58,4.6-3.51,7.98-8.38,9.63-13.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1333.86,115.71l-52.24,63.21,54.79,67.23h-33.57l-38.12-46.78-38.68,46.78h-32.03l54.8-66.31-52.26-64.12h33.56l35.6,43.69,36.12-43.69h32.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M555.72,244.07c-8.99,9-19.67,16.15-31.43,21.02-11.76,4.87-24.36,7.38-37.08,7.38s-25.33-2.51-37.08-7.38c-11.76-4.87-22.44-12.02-31.43-21.02l-68.51-68.57,68.51-68.57c18.19-18.16,42.84-28.35,68.55-28.33,25.7.02,50.35,10.24,68.51,28.42,18.17,18.18,28.37,42.83,28.36,68.53,0,25.7-10.22,50.35-28.4,68.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M175.06,0c-43.46,0-85.37,16.18-117.57,45.37C25.29,74.56,5.1,114.68.84,157.93c-4.26,43.25,7.73,86.54,33.62,121.45,25.89,34.91,63.84,58.94,106.47,67.41,42.63,8.48,86.89.8,124.17-21.54,37.28-22.34,64.92-57.75,77.54-99.34,12.62-41.59,9.32-86.38-9.26-125.67-18.58-39.29-51.11-70.27-91.26-86.9C220.86,4.53,198.07,0,175.06,0ZM272.61,251.2c-14.96,14.94-34.01,25.1-54.75,29.22-20.74,4.11-42.23,1.99-61.75-6.11-19.53-8.1-36.22-21.8-47.96-39.38-11.74-17.58-18.01-38.24-18.01-59.38s6.27-41.8,18.01-59.38c11.74-17.58,28.43-31.28,47.96-39.38,19.53-8.1,41.02-10.22,61.75-6.11,20.74,4.11,39.79,14.28,54.75,29.22l75.41,75.47-75.41,75.85Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0cca3f500962826ee5bc2f2a55a6a40f.svg";
export { ForwardRef as ReactComponent };